import { Component, Input, OnInit } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'qr-code-modal',
  templateUrl: './qr-code-modal.component.html',
  styleUrls: ['./qr-code-modal.component.scss'],
})
export class QrCodeModalComponent implements OnInit {
  @Input() title = ''
  @Input() description = ''
  @Input() url = ''
  @Input() borderColor?: string
  @Input() logModalViewed?: () => void

  constructor(protected modalService: ModalService) {}

  ngOnInit(): void {
    if (this.logModalViewed) {
      this.logModalViewed()
    }
  }

  async onClose(): Promise<void> {
    await this.modalService.dismiss()
  }
}
